import { useCallback, useMemo, useState } from "react";

import { globalEvents } from "../../../common/helpers/GlobalEvents";
import { useGlobalEvent } from "../../../common/hooks/useGlobalEvent";
import { useCartContext } from "../../../contexts/CartServiceContext/CartServiceContext";
import { CART_PAGE_EVENT } from "../constants";

export const useRemoveCartItem = () => {
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const [removeIndex, setRemoveIndex] = useState<number>(-1);

	const { state: cart } = useCartContext((state) => state.cart);

	const removeItem = useCallback(
		(index: number) => {
			if (index >= cart.length) return;
			setIsOpen(true);
			setRemoveIndex(index);
		},
		[cart]
	);

	const confirmRemove = useCallback(() => {
		globalEvents.emit(CART_PAGE_EVENT.CONFIRM_REMOVE_ITEM, removeIndex);
		setIsOpen(false);
		setRemoveIndex(-1);
	}, [removeIndex]);

	const cancelRemove = useCallback(() => {
		setIsOpen(false);
		globalEvents.emit(CART_PAGE_EVENT.RESTORE_TO_BEFORE_REMOVE, removeIndex);
	}, [removeIndex]);

	useGlobalEvent(CART_PAGE_EVENT.REMOVE_ITEM, removeItem);

	const item = useMemo(() => {
		return cart[removeIndex] ?? null;
	}, [cart, removeIndex]);

	return {
		isOpen,
		removeItem,
		cancelRemove,
		confirmRemove,
		item,
	};
};
